module.exports = __webpack_public_path__ + "img/pro_five_10.e3fd7747.jpg";